function ArrowRight(props) {
  return (
    <svg width="24" height="24" {...props}>
      <path
        fill="#FFFFFF"
        stroke="white"
        stroke-width="0"
        d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z"
      />
    </svg>
  )
}

export default ArrowRight
